/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Storage type (one of storage, storage_high, storage_insane).
 */
export var StorageType = /*#__PURE__*/function (StorageType) {
  StorageType["STORAGE"] = "storage";
  StorageType["STORAGE_HIGH"] = "storage_high";
  StorageType["STORAGE_INSANE"] = "storage_insane";
  return StorageType;
}(StorageType || {});

